import { createSlice } from "@reduxjs/toolkit";
import { getSchoolHistoryList, saveSchoolHistory, deleteSchoolHistory, setSchoolHistoryUploadProgress } from "../controller/schoolHistory.controller";
import { SchoolHistory } from "../types/schoolHistoryType";
import { SaveResponse } from "../types/common";

interface SchoolHistoryState {
  loading: boolean;
  list: SchoolHistory[];
  total: { pages: number; data: number };
  saving: boolean;
  uploadProgress: number;
  response: SaveResponse | null;
  error: string | null;
}

const initialState: SchoolHistoryState = {
  loading: false,
  list: [],
  total: { pages: 0, data: 0 },
  saving: false,
  uploadProgress: 0,
  response: null,
  error: null,
};

const schoolHistorySlice = createSlice({
  name: "schoolHistory",
  initialState,
  reducers: {
    resetSchoolHistoryResponse: (state) => {
      state.response = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getSchoolHistoryList.pending, (state) => {
        state.loading = true;
      })
      .addCase(getSchoolHistoryList.fulfilled, (state, action) => {
        state.loading = false;
        state.list = action.payload.data?.data ?? [];
        state.total = action.payload.data?.total ?? { pages: 0, data: 0 };
      })
      .addCase(getSchoolHistoryList.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message ?? "Gagal memuat data profil sekolah";
      })
      .addCase(setSchoolHistoryUploadProgress, (state, action) => {
        state.uploadProgress = action.payload;
      })
      .addCase(saveSchoolHistory.pending, (state) => {
        state.loading = true;
        state.saving = true;
        state.uploadProgress = 0;
      })
      .addCase(saveSchoolHistory.fulfilled, (state, action) => {
        state.loading = false;
        state.saving = false;
        state.response = action.payload;
      })
      .addCase(saveSchoolHistory.rejected, (state, action) => {
        state.loading = false;
        state.saving = false;
        state.error = action.error.message ?? "Gagal menyimpan profil sekolah";
      })
      .addCase(deleteSchoolHistory.fulfilled, (state, action) => {
        state.response = action.payload;
      });
  },
});

export const { resetSchoolHistoryResponse } = schoolHistorySlice.actions;
export default schoolHistorySlice.reducer;
